/**
 * Created by markush on 5/13/17.
 */

export class MetaData {
  page: PageData
}

export interface PageData {
  total?: number;
  number?: number;
  size?: number;
  last?: number;
}

export class PageMetaData {
  public page: PageData = {}

  constructor(response: any) {
    this.page = response.meta.page;
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/PageMetaData.ts